import Control from "../../1. Core/Control";
import DataTable from "../../1. Core/Controls/DataTable/DataTable";
import NP from "../../1. Core/NP";
import {Team, UsersResponse, UserTeamRead} from "../types";
import {ServerAPI} from "../../1. Core/ServerAPI";
import Menu from "../../1. Core/Controls/Menu/Menu";
import ListItem from "../../1. Core/Controls/ListBox/ListItem";
import PlayerRatingFilterPanel from "../../Admin/Users/PlayerRatingFilterPanel";


export default class UserTeamList extends Control {


    private _dataTable: DataTable;
    private _dataWithFiltersNode: HTMLElement;

    _TeamId: number
    private _filtersPanel: PlayerRatingFilterPanel;

    constructor(settings: object) {
        super(settings);
        this._render();
    }

    _initFields(settings: object) {
        this._TeamId = null
        super._initFields(settings);
    }

    _render() {
        this.np_render();
        this.addClass('');

        this._dataWithFiltersNode = NP.createNode(this._root, 'data-with-filters-container');


        this._dataTable = new DataTable({
            ParentNode: this._dataWithFiltersNode,
            ShowSettingsButton: true,
            Class: 'app-list--avatars mdc-data-table--margin data-table-battle',
            MultiSelect: false,
            ShowRowIndex: false,
            EnableSort: false,
            ImageWidth: 32,
            Columns: [{
                Content: 'Id',
                Width: '10%',
                PropertyContent: 'id'
            }, {
                Content: 'Login',
                Width: '10%',
                PropertyContent: 'firstName'
            }, {
                Content: 'Email',
                PropertyContent: 'email',
                Width: '50%'
            }, {
                Content: 'Role',
                PropertyContent: 'role',
                Width: '10%'
            }, {
                Content: 'ApprovedAt',
                PropertyContent: 'approvedAt',
                Width: '10%'
            }, {
                Content: 'Coins',
                PropertyContent: 'coins',
                Width: '10%'
            }, {
                Content: NP.RM.getString('Diamonds'),
                PropertyContent: 'pts',
                Width: '10%'
            }],
            ShowPaginator: false,
            EvItemContextMenu: async (s: any, e: { Event: any, Item: UserTeamRead }) => {

                let menu = new Menu({
                    Items: [{
                        FontImage: NP.FontImages.delete,
                        RK: 'Remove',
                        Value: 'Remove',
                    }],
                    EvItemSelected: async (s: Menu, event: { Item: ListItem }) => {

                        switch (event.Item.getValue()) {
                            case 'Remove':
                                NP.showConfirm({
                                    Content: NP.RM.getString('AreYouS'),
                                    EvOkButtonClick: async () => {
                                        await ServerAPI.callUiApi("/user-teams/" + (e.Item as any).teamUserId, null, 'DELETE');
                                        this.refreshList();
                                    }
                                })
                                break
                        }


                    }
                });
                menu.showContextMenu(e.Event);
            }
        });

        this._filtersPanel = new PlayerRatingFilterPanel({
            ParentNode: this._dataWithFiltersNode,
            Width: 280,
            Height: this.getHeight(),
            EvFilterSortChanged: () => this.refresh()
        });

        this._filtersPanel.setIsVisible(true)

        this.refresh()
    }


    setHeight(value: number) {
        super.setHeight(value);
        this._dataTable.setHeight(value);
        this._filtersPanel.setHeight(value);
    }

    setWidth(value: number) {
        super.setWidth(value);

        if (this._filtersPanel.getIsVisible())
            value = value - 280;

        if (this._dataTable)
            this._dataTable.setWidth(value);
    }

    refresh() {
        this.refreshList();
    }

    formatNum(value: number): string {
        if (value == null) return '';
        return new Intl.NumberFormat('en-US', {
            useGrouping: true,
        }).format(value);
    }

    private async refreshList() {

        let res = await ServerAPI.post<UsersResponse>("/users/players/rating", {
            teamId: this._TeamId,
            ...this._filtersPanel.getFilterData()
        })

        let members = await ServerAPI.get<UserTeamRead[]>(`/user-teams/${this._TeamId}`)


        this._dataTable.setRows(res.users.map(it => ({
            ...it,
            teamUserId: members.find(u => u.userId == it.id)?.id,
            pts: this.formatNum(it.pts),
            coins: this.formatNum(it.coins),
            role: members.find(u => u.userId == it.id)?.role,
            approvedAt: members.find(u => u.userId == it.id)?.approvedAt
        })));
    }
}